import { render, staticRenderFns } from "./ModalEditIncorporation.vue?vue&type=template&id=847af9a8&"
import script from "./ModalEditIncorporation.vue?vue&type=script&lang=ts&"
export * from "./ModalEditIncorporation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports